import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Banner, Button } from '@electricjs/arc';
import { skipToken } from '@reduxjs/toolkit/query';
import { Asset } from '@/types/assets';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useGetOrganizationApplicationByOrganizationApplicationIdQuery } from '@/redux/slices/organizationApiSlice';

export const DeviceManagedExternallyBanner = ({ asset }: { asset: Asset }) => {
  const { t } = useTranslation('assets');
  const navigate = useNavigate();
  const organizationId = useGetOrganizationId();
  const mdmProviderId = asset.device?.mdmProviderId;

  const { data: organizationApplication } =
    useGetOrganizationApplicationByOrganizationApplicationIdQuery(
      mdmProviderId
        ? { organizationApplicationId: mdmProviderId, organizationId }
        : skipToken
    );

  return (
    <Banner
      intent="info"
      isFlat
      title={t('assetDetailsContent.deviceManagedExternally.title')}
      id="device-managed-externally-banner"
      isFullWidth
      message={t('assetDetailsContent.deviceManagedExternally.message', {
        applicationName: organizationApplication?.application.name,
      })}
      cta={
        organizationApplication && (
          <Button
            id="view-application-button"
            variant="link"
            onClick={() =>
              navigate(
                `/applications/${organizationApplication.application.slug}`
              )
            }>
            {t('assetDetailsContent.deviceManagedExternally.viewApplication')}
          </Button>
        )
      }
    />
  );
};
